module.exports = __webpack_public_path__ + "img/76_1.d3d44e21.png";